import * as yup from 'yup';
import {
  NICKNAME_INVALID,
  CHECKING_ACCOUNT_NUMBER_INVALID,
  CHECKING_ACCOUNT_ROUTING_INVALID,
  GIFT_CARD_ENOUGH_DIGITS,
  GIFT_CARD_REQUIRED,
  KEYTAG_NUMBER_INVALID,
  CHECKING_ACCOUNT_NUMBER_TOO_LONG,
} from '../../../constants/field-error-messages';
import {
  NICKNAME_REGEX,
  NUMBERS_REGEX,
  CHECKING_ACCOUNT_ROUTING_REGEX,
  KEYTAG_NUMBER_REGEX,
} from '../../../constants/regex';

export const giftCardValidationSchema = yup.object().shape({
  cardNickName: yup
    .string()
    .matches(NICKNAME_REGEX, { message: NICKNAME_INVALID.message }),

  cardNumber: yup
    .string()
    .trim()
    .required(GIFT_CARD_REQUIRED.message)
    .min(26, GIFT_CARD_ENOUGH_DIGITS.message)
    .max(26, GIFT_CARD_ENOUGH_DIGITS.message),
});

export const keytagValidationSchema = yup.object().shape({
  cardNickName: yup
    .string()
    .matches(NICKNAME_REGEX, { message: NICKNAME_INVALID.message }),
  cardNumber: yup
    .string()
    .trim()
    .required(KEYTAG_NUMBER_INVALID.message)
    .matches(KEYTAG_NUMBER_REGEX, { message: KEYTAG_NUMBER_INVALID.message }),
});

export const checkingAccountValidationSchema = yup.object().shape({
  cardNickName: yup
    .string()
    .matches(NICKNAME_REGEX, { message: NICKNAME_INVALID.message }),

  cardNumber: yup
    .string()
    .trim()
    .required(CHECKING_ACCOUNT_NUMBER_INVALID.message)
    .matches(NUMBERS_REGEX, {
      message: CHECKING_ACCOUNT_NUMBER_INVALID.message,
    })
    .min(4, CHECKING_ACCOUNT_NUMBER_INVALID.message)
    .max(18, CHECKING_ACCOUNT_NUMBER_TOO_LONG.message),

  routingNumber: yup
    .string()
    .trim()
    .required(CHECKING_ACCOUNT_ROUTING_INVALID.message)
    .matches(CHECKING_ACCOUNT_ROUTING_REGEX, {
      message: CHECKING_ACCOUNT_ROUTING_INVALID.message,
    }),
});
